import { render, staticRenderFns } from "./LandingSignupBabyNeeds.vue?vue&type=template&id=99a0a512"
import script from "./LandingSignupBabyNeeds.vue?vue&type=script&lang=js"
export * from "./LandingSignupBabyNeeds.vue?vue&type=script&lang=js"
import style0 from "./LandingSignupBabyNeeds.vue?vue&type=style&index=0&id=99a0a512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports